window.deferScript = window.deferScript || function(config) {
  if (!window._deferScriptQueue) {
    window._deferScriptQueue = [];
  }
  window._deferScriptQueue.push(config);
};

(function() {
  'use strict';

  let scriptsLoaded = false;
  let loadTimeout = null;
  let consentGranted = false;
  let consentCheckInterval = null;
  let barVisibilityInterval = null;

  const scriptQueue = [];
  const trackingScriptQueue = [];

  function checkConsent() {
    if (window.__tcfapi) {
      return new Promise(function(resolve) {
        window.__tcfapi('getTCData', 2, function(tcData, success) {
          if (success && tcData) {
            const hasConsent = tcData.gdprApplies === false ||
              (tcData.purpose && tcData.purpose.consents &&
               tcData.purpose.consents[1] && tcData.purpose.consents[7]);
            resolve(hasConsent);
          } else {
            resolve(false);
          }
        });
      });
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      const shopifyConsent = window.Shopify.customerPrivacy.getTrackingConsent() === true;
      return shopifyConsent;
    }

    if (window.goodgConsent || window.goodg_consent || window.goodAppsGDPRConsent) {
      return true;
    }

    const allCookies = document.cookie.split(';').map(c => c.trim());
    for (let i = 0; i < allCookies.length; i++) {
      const cookieParts = allCookies[i].split('=');
      const cookieName = cookieParts[0].toLowerCase();
      const cookieValue = cookieParts.slice(1).join('=');

      if (cookieName.includes('goodg') || cookieName.includes('good-apps') || cookieName.includes('gdpr')) {
        // goodg_block_popup cookie existence indicates consent was given (GoodApps uses it to prevent showing popup again)
        // Even if the value is empty, the cookie's existence means the user interacted with the banner
        if (cookieName === 'goodg_block_popup') {
          return true;
        }
        
        if (cookieValue === 'true' || cookieValue === '1' || cookieValue === 'granted' || cookieValue === 'accepted' || cookieValue === 'yes') {
          return true;
        }
        try {
          const cookieData = JSON.parse(decodeURIComponent(cookieValue));
          if (cookieData === true || cookieData.consent === true || cookieData.accepted === true || cookieData.marketing === true || cookieData.analytics === true) {
            return true;
          }
        } catch (e) {
        }
      }
    }

    try {
      const localStorageKeys = Object.keys(localStorage);
      for (let i = 0; i < localStorageKeys.length; i++) {
        const key = localStorageKeys[i].toLowerCase();
        if (key.includes('goodg') || key.includes('good-apps') || key.includes('gdpr') || key.includes('consent')) {
          try {
            const value = localStorage.getItem(localStorageKeys[i]);
            if (value === 'true' || value === '1' || value === 'granted' || value === 'accepted' || value === 'yes') {
              return true;
            }
            const valueData = JSON.parse(value);
            if (valueData === true || valueData.consent === true || valueData.accepted === true || valueData.marketing === true || valueData.analytics === true) {
              return true;
            }
          } catch (e) {
          }
        }
      }
    } catch (e) {
      // localStorage access blocked (e.g., in privacy mode)
    }

    try {
      const consent = localStorage.getItem('cookie-consent') ||
                     localStorage.getItem('gdpr-consent') ||
                     localStorage.getItem('marketing-consent') ||
                     localStorage.getItem('goodg-consent') ||
                     localStorage.getItem('goodg_cookie_consent') ||
                     localStorage.getItem('good_apps_gdpr_consent');
      if (consent) {
        try {
          const consentData = JSON.parse(consent);
          if (consentData.marketing === true || consentData.analytics === true || consentData === true) {
            return true;
          }
        } catch (e) {
        }
      }
    } catch (e) {
      // localStorage access blocked or JSON parse error
      try {
        const consent = localStorage.getItem('cookie-consent') ||
                       localStorage.getItem('gdpr-consent') ||
                       localStorage.getItem('marketing-consent') ||
                       localStorage.getItem('goodg-consent') ||
                       localStorage.getItem('goodg_cookie_consent') ||
                       localStorage.getItem('good_apps_gdpr_consent');
        if (consent === 'true' || consent === '1' || consent === 'granted' || consent === 'accepted') {
          return true;
        }
      } catch (e2) {
        // localStorage access blocked (e.g., in privacy mode)
      }
    }

    const consentCookies = [
      'cookie-consent',
      'gdpr-consent',
      'marketing-consent',
      'analytics-consent',
      'goodg-consent',
      'goodg_cookie_consent',
      'good_apps_gdpr_consent',
      'goodg_consent'
    ];
    for (let i = 0; i < consentCookies.length; i++) {
      const cookie = getCookie(consentCookies[i]);
      if (cookie) {
        if (cookie === 'true' || cookie === '1' || cookie === 'granted' || cookie === 'accepted') {
          return true;
        }
        try {
          const cookieData = JSON.parse(cookie);
          if (cookieData.marketing === true || cookieData.analytics === true || cookieData === true) {
            return true;
          }
        } catch (e) {
        }
      }
    }

    return false;
  }

  function getCookie(name) {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  }

  function isTrackingScript(config) {
    const src = config.src || '';
    const inline = config.inline || '';
    const combined = src + ' ' + inline;

    // Klaviyo is excluded from the consent-gated tracking queue.
    if (combined.toLowerCase().indexOf('klaviyo.com') !== -1) {
      return false;
    }

    const trackingPatterns = [
      'google-analytics',
      'googletagmanager',
      'gtag',
      'analytics',
      'facebook',
      'fbcdn',
      'fbq',
      'facebook.net',
      'clarity',
      'clarity.ms',
      'wknd.ai',
      'remarketing',
      'conversion',
      'pixel',
      'tracking',
      'tagmanager'
    ];

    return trackingPatterns.some(pattern =>
      combined.toLowerCase().includes(pattern.toLowerCase())
    );
  }

  function initConsent() {
    if (window.__tcfapi) {
      checkConsent().then(function(hasConsent) {
        consentGranted = hasConsent;
        if (hasConsent) {
          processTrackingQueue();
        }
      });
    } else {
      const initialConsent = checkConsent();
      if (initialConsent && typeof initialConsent.then === 'function') {
        initialConsent.then(function(hasConsent) {
          consentGranted = hasConsent;
          if (hasConsent) {
            processTrackingQueue();
          }
        });
      } else {
        consentGranted = initialConsent;
        if (consentGranted) {
          processTrackingQueue();
        }
      }
    }

    listenForConsentChanges();

    setTimeout(function() {
      if (!consentGranted) {
        const delayedConsent = checkConsent();
        if (delayedConsent && typeof delayedConsent.then === 'function') {
          delayedConsent.then(function(hasConsent) {
            if (hasConsent && !consentGranted) {
              consentGranted = true;
              processTrackingQueue();
            }
          });
        } else if (delayedConsent && !consentGranted) {
          consentGranted = true;
          processTrackingQueue();
        }
      }
    }, 500);
  }

  function setupGoodAppsGDPRListener() {
    const goodgApp = document.getElementById('goodg-app');
    if (goodgApp) {
      const acceptButton = goodgApp.querySelector('.goodg-cart__checkout');
      if (acceptButton) {
        acceptButton.addEventListener('click', function(e) {
          consentGranted = true;
          processTrackingQueue();

          setTimeout(function() {
            const hasConsent = checkConsent();
            if (hasConsent && typeof hasConsent.then === 'function') {
              hasConsent.then(function(consent) {
                if (consent && !consentGranted) {
                  consentGranted = true;
                  processTrackingQueue();
                }
              });
            } else {
              if (hasConsent && !consentGranted) {
                consentGranted = true;
                processTrackingQueue();
              }
            }
          }, 50);
        }, true);
      }

      const checkBarVisibility = function() {
        const app = document.getElementById('goodg-app');
        if (!app) {
          return true;
        }
        const isHidden = app.style.display === 'none' ||
                        app.getAttribute('style')?.includes('display: none') ||
                        window.getComputedStyle(app).display === 'none' ||
                        app.classList.contains('hide') ||
                        app.hasAttribute('hidden') ||
                        app.offsetHeight === 0 ||
                        app.offsetWidth === 0;
        return isHidden;
      };

      const observer = new MutationObserver(function(mutations) {
        if (consentGranted) {
          observer.disconnect();
          if (barVisibilityInterval) {
            clearInterval(barVisibilityInterval);
            barVisibilityInterval = null;
          }
          return;
        }
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' || mutation.type === 'childList') {
            checkBarVisibility();
          }
        });
      });

      observer.observe(goodgApp, {
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden'],
        childList: true,
        subtree: true
      });

      barVisibilityInterval = setInterval(function() {
        const isHidden = checkBarVisibility();
        if (isHidden && consentGranted && barVisibilityInterval) {
          clearInterval(barVisibilityInterval);
          barVisibilityInterval = null;
        }
      }, 200);

      return true;
    }
    return false;
  }

  function waitForGoodAppsGDPR() {
    if (setupGoodAppsGDPRListener()) {
      return;
    }

    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.id === 'goodg-app' || node.querySelector && node.querySelector('#goodg-app'))) {
            setupGoodAppsGDPRListener();
            bodyObserver.disconnect();
          }
        });
      });
    });

    if (document.body) {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function() {
        bodyObserver.disconnect();
      }, 10000);
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        if (document.body) {
          bodyObserver.observe(document.body, { childList: true, subtree: true });
          setTimeout(function() {
            bodyObserver.disconnect();
          }, 10000);
        }
      });
    }
  }

  function listenForConsentChanges() {
    if (window.__tcfapi) {
      window.__tcfapi('addEventListener', 2, function(tcData, success) {
        if (success && tcData) {
          const hasConsent = tcData.gdprApplies === false ||
            (tcData.purpose && tcData.purpose.consents &&
             tcData.purpose.consents[1] && tcData.purpose.consents[7]);
          if (hasConsent && !consentGranted) {
            consentGranted = true;
            processTrackingQueue();
          }
        }
      });
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      document.addEventListener('trackingConsentAccepted', function() {
        consentGranted = true;
        processTrackingQueue();
      }, { once: true });
    }

    waitForGoodAppsGDPR();

    let lastConsentCheck = consentGranted;
    consentCheckInterval = setInterval(function() {
      if (consentGranted && consentCheckInterval) {
        clearInterval(consentCheckInterval);
        consentCheckInterval = null;
        return;
      }
      const consentResult = checkConsent();
      if (consentResult && typeof consentResult.then === 'function') {
        consentResult.then(function(currentConsent) {
          if (currentConsent && !consentGranted) {
            lastConsentCheck = true;
            consentGranted = true;
            processTrackingQueue();
            if (consentCheckInterval) {
              clearInterval(consentCheckInterval);
              consentCheckInterval = null;
            }
          } else if (currentConsent !== lastConsentCheck && currentConsent) {
            lastConsentCheck = currentConsent;
            consentGranted = true;
            if (consentCheckInterval) {
              clearInterval(consentCheckInterval);
              consentCheckInterval = null;
            }
          }
        });
      } else {
        const currentConsent = consentResult;
        if (currentConsent && !consentGranted) {
          lastConsentCheck = true;
          consentGranted = true;
          processTrackingQueue();
          if (consentCheckInterval) {
            clearInterval(consentCheckInterval);
            consentCheckInterval = null;
          }
        } else if (currentConsent && currentConsent !== lastConsentCheck) {
          lastConsentCheck = currentConsent;
          consentGranted = true;
          if (consentCheckInterval) {
            clearInterval(consentCheckInterval);
            consentCheckInterval = null;
          }
        }
      }
    }, 1000);
  }

  function processTrackingQueue() {
    if (!consentGranted) {
      return;
    }

    // Stop polling intervals once consent is granted
    if (consentCheckInterval) {
      clearInterval(consentCheckInterval);
      consentCheckInterval = null;
    }
    if (barVisibilityInterval) {
      clearInterval(barVisibilityInterval);
      barVisibilityInterval = null;
    }

    trackingScriptQueue.forEach(function(config) {
      if (!config.loaded) {
        loadScript(config);
      }
    });
  }

  window.deferScript = function(config) {
    const requiresConsent = config.requiresConsent !== undefined
      ? config.requiresConsent === true
      : isTrackingScript(config);

    if (requiresConsent) {
      trackingScriptQueue.push(config);

      if (consentGranted) {
        loadScript(config);
      }
    } else {
      if (scriptsLoaded) {
        loadScript(config);
      } else {
        scriptQueue.push(config);
      }
    }
  };

  if (window._deferScriptQueue && window._deferScriptQueue.length > 0) {
    window._deferScriptQueue.forEach(function(config) {
      window.deferScript(config);
    });
    window._deferScriptQueue = [];
  }

  function loadScript(config) {
    if (config.loaded) {
      return;
    }
    const script = document.createElement('script');

    if (config.attributes) {
      Object.keys(config.attributes).forEach(key => {
        script.setAttribute(key, config.attributes[key]);
      });
    }

    if (config.src) {
      script.src = config.src;
    } else if (config.inline) {
      script.textContent = config.inline;
    }

    if (config.async !== false) {
      script.async = true;
    }
    if (config.defer) {
      script.defer = true;
    }

    if (config.onload) {
      script.onload = config.onload;
    }

    (config.target === 'body' ? document.body : document.head).appendChild(script);
    config.loaded = true;
  }

  function processQueue() {
    if (scriptsLoaded) {
      return;
    }
    scriptsLoaded = true;

    if (loadTimeout) {
      clearTimeout(loadTimeout);
      loadTimeout = null;
    }

    scriptQueue.forEach(function(config) {
      loadScript(config);
    });

    if (consentGranted) {
      processTrackingQueue();
    }
  }

  function loadOnInteraction() {
    const events = ['mousedown', 'touchstart', 'keydown', 'scroll', 'click'];
    const handler = function() {
      processQueue();
      events.forEach(event => {
        document.removeEventListener(event, handler, { passive: true });
      });
    };

    events.forEach(event => {
      document.addEventListener(event, handler, { passive: true, once: true });
    });
  }

  function loadOnIdle() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(processQueue, { timeout: 2000 });
    } else {
      setTimeout(processQueue, 2000);
    }
  }

  function init() {
    initConsent();
    loadOnInteraction();

    loadTimeout = setTimeout(function() {
      if (!scriptsLoaded) {
        processQueue();
      }
    }, 3000);

    loadOnIdle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function interceptContentForHeader() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeName === 'SCRIPT') {
            const script = node;
            const src = script.src;
            const isInline = !src && script.textContent;

            // Klaviyo is excluded so sign-up forms and onsite tracking can load.
            if (src && src.indexOf('klaviyo.com') !== -1) {
              return;
            }

            const isRebuy = src && src.includes('rebuy');
            const shouldLoadRebuy = isRebuy && (
              window.location.pathname.includes('/products/') ||
              window.location.pathname.includes('/cart') ||
              window.location.pathname.includes('/checkout')
            );

            if (isRebuy && !shouldLoadRebuy) {
              script.remove();
              return;
            }

            const isThirdParty = src && (
              (isRebuy && shouldLoadRebuy) ||
              (!isRebuy && (
                src.includes('intelligems') ||
                src.includes('facebook') ||
                src.includes('fbcdn') ||
                src.includes('gdpr') ||
                src.includes('consent') ||
                src.includes('freshbots') ||
                src.includes('stamped') ||
                src.includes('clarity') ||
                src.includes('googletagmanager') ||
                src.includes('analytics') ||
                src.includes('tagmanager') ||
                src.includes('wknd.ai')
              ))
            );

            const isCritical = src && (
              src.includes('checkout') ||
              src.includes('cart') ||
              (src.includes('shopify') && !src.includes('apps'))
            );

            if (isThirdParty && !isCritical && !script.hasAttribute('data-deferred')) {
              script.setAttribute('data-deferred', 'true');
              script.remove();

              const config = {
                src: isInline ? undefined : src,
                inline: isInline ? script.textContent : undefined,
                async: true,
                loaded: false
              };

              if (script.attributes) {
                config.attributes = {};
                Array.from(script.attributes).forEach(attr => {
                  if (attr.name !== 'src') {
                    config.attributes[attr.name] = attr.value;
                  }
                });
              }

              window.deferScript(config);
            }
          }
        });
      });
    });

    if (document.head) {
      observer.observe(document.head, { childList: true, subtree: true });
    }
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      const observeBody = function() {
        if (document.body) {
          observer.observe(document.body, { childList: true, subtree: true });
        } else {
          setTimeout(observeBody, 10);
        }
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeBody);
      } else {
        observeBody();
      }
    }
  }

  (function startInterception() {
    if (document.head) {
      interceptContentForHeader();
    } else {
      setTimeout(function() {
        if (document.head) {
          interceptContentForHeader();
        } else {
          document.addEventListener('DOMContentLoaded', function() {
            interceptContentForHeader();
          });
        }
      }, 0);
    }
  })();
})();
